export const AutoReserveTableIcon = () => {
  return (
    <svg
      width="220"
      height="80"
      viewBox="0 0 220 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="79.1211"
        width="79.1217"
        height="58.3665"
        rx="11.0867"
        transform="rotate(-90 0 79.1211)"
        fill="url(#paint0_linear_2396_5959)"
      />
      <rect
        y="79.1211"
        width="79.1217"
        height="58.3665"
        rx="11.0867"
        transform="rotate(-90 0 79.1211)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject
        x="-0.810407"
        y="-1.62608"
        width="61.2107"
        height="82.3693"
      >
        <div
          style={{
            backdropFilter: "blur(3.24px)",
            clipPath: "url(#bgblur_0_2396_5959_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.5"
        filter="url(#filter0_i_2396_5959)"
        data-figma-bg-blur-radius="6.47178"
      >
        <rect
          x="53.9285"
          y="74.2715"
          width="48.2671"
          height="69.4254"
          rx="8.78436"
          transform="rotate(-180 53.9285 74.2715)"
          fill="url(#paint1_linear_2396_5959)"
        />
        <rect
          x="53.7293"
          y="74.0724"
          width="47.8688"
          height="69.0271"
          rx="8.58523"
          transform="rotate(-180 53.7293 74.0724)"
          stroke="url(#paint2_linear_2396_5959)"
          strokeWidth="0.398264"
        />
      </g>
      <path
        d="M96.4343 54.6777C96.4343 54.6476 96.4372 54.6173 96.4431 54.5879L96.4695 54.5029C96.4809 54.4753 96.4949 54.4486 96.5115 54.4238L96.5681 54.3545V54.3535L100.689 50.2334L100.694 50.2275L100.7 50.2227C100.721 50.2007 100.744 50.1803 100.769 50.1631L100.848 50.1201C100.876 50.1081 100.906 50.099 100.935 50.0928L101.025 50.083C101.055 50.0827 101.085 50.0852 101.115 50.0908L101.202 50.1162C101.258 50.1392 101.309 50.1739 101.352 50.2168C101.374 50.2383 101.393 50.2619 101.41 50.2871L101.453 50.3672C101.476 50.4233 101.488 50.4834 101.487 50.5439L101.477 50.6338L101.45 50.7207C101.426 50.7764 101.391 50.827 101.347 50.8691L97.9968 54.2197H113.374L113.6 54.208C114.049 54.1631 114.475 53.9871 114.824 53.7012L114.992 53.5488C115.367 53.1734 115.599 52.681 115.651 52.1572L115.663 51.9307V24.4609C115.663 24.3699 115.69 24.2817 115.74 24.207L115.797 24.1377C115.882 24.052 115.999 24.004 116.12 24.0039C116.211 24.0039 116.299 24.0313 116.374 24.0811L116.444 24.1377C116.53 24.2234 116.578 24.3398 116.578 24.4609V51.9297C116.577 52.7263 116.28 53.4924 115.748 54.0801L115.638 54.1953C115.075 54.7588 114.323 55.0908 113.531 55.1309L113.373 55.1348H97.9968L99.5603 56.6982L101.328 58.4678C101.409 58.5536 101.454 58.6671 101.453 58.7852L101.443 58.873C101.431 58.9309 101.409 58.986 101.376 59.0352L101.319 59.1045C101.255 59.1682 101.175 59.2106 101.088 59.2285L101 59.2383C100.882 59.2393 100.767 59.1951 100.681 59.1143L96.5681 55.001V55C96.5471 54.979 96.5279 54.9562 96.5115 54.9316L96.4695 54.8525C96.4466 54.7972 96.4344 54.7376 96.4343 54.6777ZM89.5671 54.6777V27.209L89.571 27.0498C89.6113 26.258 89.9434 25.5066 90.5066 24.9434C91.0701 24.3799 91.8219 24.0478 92.614 24.0078L92.7722 24.0039H108.148L106.585 22.4404L104.809 20.6641C104.788 20.6428 104.768 20.6196 104.752 20.5947L104.71 20.5156C104.687 20.4602 104.675 20.4008 104.675 20.3408C104.675 20.3109 104.678 20.2811 104.683 20.252L104.71 20.166C104.721 20.1383 104.735 20.1117 104.752 20.0869L104.809 20.0176C104.831 19.9963 104.854 19.9766 104.879 19.96L104.958 19.918C105.013 19.895 105.073 19.8828 105.133 19.8828C105.162 19.8828 105.192 19.8858 105.221 19.8916L105.307 19.918C105.335 19.9294 105.362 19.9434 105.386 19.96L105.456 20.0176L109.576 24.1377H109.577C109.619 24.1801 109.653 24.2308 109.676 24.2861C109.698 24.3415 109.711 24.401 109.711 24.4609C109.711 24.5209 109.698 24.5804 109.676 24.6357C109.664 24.6634 109.65 24.6901 109.634 24.7148L109.577 24.7842H109.576L105.467 28.8945C105.402 28.9567 105.321 28.9983 105.234 29.0146L105.145 29.0225C105.025 29.0214 104.911 28.9733 104.826 28.8887C104.762 28.825 104.72 28.7441 104.702 28.6572L104.692 28.5684C104.691 28.4784 104.717 28.3909 104.765 28.3164L104.82 28.2471L108.148 24.9189H92.7712L92.5447 24.9297C92.0209 24.982 91.5286 25.2143 91.1531 25.5898C90.7776 25.9653 90.5462 26.4576 90.4939 26.9814L90.4822 27.208V54.6777C90.4821 54.7688 90.4549 54.857 90.405 54.9316L90.3484 55.001C90.2626 55.0868 90.1455 55.1348 90.0242 55.1348C89.9331 55.1347 89.8449 55.1075 89.7703 55.0576L89.7009 55.001C89.6152 54.9153 89.5672 54.7989 89.5671 54.6777Z"
        fill="url(#paint3_linear_2396_5959)"
      />
      <path
        d="M96.4343 54.6777C96.4343 54.6476 96.4372 54.6173 96.4431 54.5879L96.4695 54.5029C96.4809 54.4753 96.4949 54.4486 96.5115 54.4238L96.5681 54.3545V54.3535L100.689 50.2334L100.694 50.2275L100.7 50.2227C100.721 50.2007 100.744 50.1803 100.769 50.1631L100.848 50.1201C100.876 50.1081 100.906 50.099 100.935 50.0928L101.025 50.083C101.055 50.0827 101.085 50.0852 101.115 50.0908L101.202 50.1162C101.258 50.1392 101.309 50.1739 101.352 50.2168C101.374 50.2383 101.393 50.2619 101.41 50.2871L101.453 50.3672C101.476 50.4233 101.488 50.4834 101.487 50.5439L101.477 50.6338L101.45 50.7207C101.426 50.7764 101.391 50.827 101.347 50.8691L97.9968 54.2197H113.374L113.6 54.208C114.049 54.1631 114.475 53.9871 114.824 53.7012L114.992 53.5488C115.367 53.1734 115.599 52.681 115.651 52.1572L115.663 51.9307V24.4609C115.663 24.3699 115.69 24.2817 115.74 24.207L115.797 24.1377C115.882 24.052 115.999 24.004 116.12 24.0039C116.211 24.0039 116.299 24.0313 116.374 24.0811L116.444 24.1377C116.53 24.2234 116.578 24.3398 116.578 24.4609V51.9297C116.577 52.7263 116.28 53.4924 115.748 54.0801L115.638 54.1953C115.075 54.7588 114.323 55.0908 113.531 55.1309L113.373 55.1348H97.9968L99.5603 56.6982L101.328 58.4678C101.409 58.5536 101.454 58.6671 101.453 58.7852L101.443 58.873C101.431 58.9309 101.409 58.986 101.376 59.0352L101.319 59.1045C101.255 59.1682 101.175 59.2106 101.088 59.2285L101 59.2383C100.882 59.2393 100.767 59.1951 100.681 59.1143L96.5681 55.001V55C96.5471 54.979 96.5279 54.9562 96.5115 54.9316L96.4695 54.8525C96.4466 54.7972 96.4344 54.7376 96.4343 54.6777ZM89.5671 54.6777V27.209L89.571 27.0498C89.6113 26.258 89.9434 25.5066 90.5066 24.9434C91.0701 24.3799 91.8219 24.0478 92.614 24.0078L92.7722 24.0039H108.148L106.585 22.4404L104.809 20.6641C104.788 20.6428 104.768 20.6196 104.752 20.5947L104.71 20.5156C104.687 20.4602 104.675 20.4008 104.675 20.3408C104.675 20.3109 104.678 20.2811 104.683 20.252L104.71 20.166C104.721 20.1383 104.735 20.1117 104.752 20.0869L104.809 20.0176C104.831 19.9963 104.854 19.9766 104.879 19.96L104.958 19.918C105.013 19.895 105.073 19.8828 105.133 19.8828C105.162 19.8828 105.192 19.8858 105.221 19.8916L105.307 19.918C105.335 19.9294 105.362 19.9434 105.386 19.96L105.456 20.0176L109.576 24.1377H109.577C109.619 24.1801 109.653 24.2308 109.676 24.2861C109.698 24.3415 109.711 24.401 109.711 24.4609C109.711 24.5209 109.698 24.5804 109.676 24.6357C109.664 24.6634 109.65 24.6901 109.634 24.7148L109.577 24.7842H109.576L105.467 28.8945C105.402 28.9567 105.321 28.9983 105.234 29.0146L105.145 29.0225C105.025 29.0214 104.911 28.9733 104.826 28.8887C104.762 28.825 104.72 28.7441 104.702 28.6572L104.692 28.5684C104.691 28.4784 104.717 28.3909 104.765 28.3164L104.82 28.2471L108.148 24.9189H92.7712L92.5447 24.9297C92.0209 24.982 91.5286 25.2143 91.1531 25.5898C90.7776 25.9653 90.5462 26.4576 90.4939 26.9814L90.4822 27.208V54.6777C90.4821 54.7688 90.4549 54.857 90.405 54.9316L90.3484 55.001C90.2626 55.0868 90.1455 55.1348 90.0242 55.1348C89.9331 55.1347 89.8449 55.1075 89.7703 55.0576L89.7009 55.001C89.6152 54.9153 89.5672 54.7989 89.5671 54.6777Z"
        fill="black"
        fillOpacity={0.1}
        strokeWidth="1.83182"
      />
      <rect
        x="147.778"
        y="75.6719"
        width="72.2215"
        height="72.2215"
        rx="36.1108"
        transform="rotate(-90 147.778 75.6719)"
        fill="url(#paint4_linear_2396_5959)"
      />
      <rect
        x="147.778"
        y="75.6719"
        width="72.2215"
        height="72.2215"
        rx="36.1108"
        transform="rotate(-90 147.778 75.6719)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="142.253" y="-5.25695" width="83.2112" height="87.303">
        <div
          style={{
            backdropFilter: "blur(8.87px)",
            clipPath: "url(#bgblur_1_2396_5959_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter1_i_2396_5959)"
        data-figma-bg-blur-radius="17.7335"
      >
        <rect
          x="207.731"
          y="64.3125"
          width="47.7441"
          height="51.8364"
          rx="23.452"
          transform="rotate(-180 207.731 64.3125)"
          fill="url(#paint5_linear_2396_5959)"
        />
        <rect
          x="207.185"
          y="63.7669"
          width="46.6528"
          height="50.7451"
          rx="22.9063"
          transform="rotate(-180 207.185 63.7669)"
          stroke="url(#paint6_linear_2396_5959)"
          strokeWidth="1.09129"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_2396_5959"
          x="-0.810407"
          y="-1.62608"
          width="61.2107"
          height="82.3693"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4.97829"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_2396_5959"
          />
          <feOffset dx="-2.98698" dy="2.98698" />
          <feGaussianBlur stdDeviation="1.99132" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2396_5959"
          />
        </filter>
        <clipPath
          id="bgblur_0_2396_5959_clip_path"
          transform="translate(0.810407 1.62608)"
        >
          <rect
            x="53.9285"
            y="74.2715"
            width="48.2671"
            height="69.4254"
            rx="8.78436"
            transform="rotate(-180 53.9285 74.2715)"
          />
        </clipPath>
        <filter
          id="filter1_i_2396_5959"
          x="142.253"
          y="-5.25695"
          width="83.2112"
          height="87.303"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="13.6412"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_2396_5959"
          />
          <feOffset dx="-8.1847" dy="8.1847" />
          <feGaussianBlur stdDeviation="5.45647" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2396_5959"
          />
        </filter>
        <clipPath
          id="bgblur_1_2396_5959_clip_path"
          transform="translate(-142.253 5.25695)"
        >
          <rect
            x="207.731"
            y="64.3125"
            width="47.7441"
            height="51.8364"
            rx="23.452"
            transform="rotate(-180 207.731 64.3125)"
          />
        </clipPath>
        <linearGradient
          id="paint0_linear_2396_5959"
          x1="16.256"
          y1="79.1211"
          x2="65.5255"
          y2="153.949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2396_5959"
          x1="53.9285"
          y1="108.984"
          x2="102.196"
          y2="108.984"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2396_5959"
          x1="53.9285"
          y1="79.6579"
          x2="87.105"
          y2="142.239"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2396_5959"
          x1="88.6511"
          y1="51.6922"
          x2="126.767"
          y2="27.8672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2396_5959"
          x1="162.617"
          y1="75.6719"
          x2="228.556"
          y2="149.547"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2396_5959"
          x1="207.731"
          y1="90.2307"
          x2="255.475"
          y2="90.2307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2396_5959"
          x1="207.731"
          y1="68.3343"
          x2="228.378"
          y2="119.931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};
